import { DynamicToolUIPart, ToolUIPart } from 'ai';
import { VizBlock } from '../../../../genui/viz.types';

const isVizBlock = (block: unknown): block is VizBlock =>
  typeof block === 'object' && block !== null && 'kind' in block;

export const getWebVisualizationBlocks = (part: ToolUIPart | DynamicToolUIPart): VizBlock[] => {
  if (part.state !== 'output-available') {
    return [];
  }

  const blocks = (part.output as { blocks?: unknown } | undefined)?.blocks;
  if (!Array.isArray(blocks)) {
    return [];
  }

  return blocks.filter(isVizBlock).filter((block) => (block.channel ?? 'web') === 'web');
};
